module.exports = __webpack_public_path__ + "static/img/index-pro-智慧工地.74fa79c3.png";